// Howtopartcipate.js
import React from "react";
import { Link } from "react-router-dom";

// import './Howtopartcipate.css';
import "./css/Howtopartcipate.css";
const Howtopartcipate = () => {
  return (
    <div>
      <div className="howto-participate-page">
        {/* Navbar placeholder - if you have a Navbar component include it above this component */}
        {/* <header className="howtoparticipate-header">
          <div className="tm-container">
            <div className="brand-row">
              <div className="brand-left">
                <img
                  src="../images/docmasterLogo.png"
                  alt="DocMaster Quiz"
                  className="tm-logo"
                />
              </div>
              <nav className="brand-nav">
                <Link to="/quizhomepage">Home</Link>
                <Link to="/quiz-dashboard">Dashboard</Link>
                <Link to="/quiz-syllabus">Syllabus</Link>
                <Link to="/participate" className="active">
                  How to Participate
                </Link>
                <Link to="/testimonials">Testimonials</Link>
                <Link to="/contact">Contact</Link>
              </nav>
              <div className="brand-actions">
                <button className="btn-outline">Sign In</button>
                <button className="btn-primary">Get Started</button>
              </div>
            </div>
          </div>
        </header> */}

        {/* Hero Section */}
        <section className="hero-section">
          <h1 className="hero-title">How to Register & Participate</h1>
          <p className="hero-subtitle">
            Join the DocMaster Quiz community in just a few simple steps and
            start your learning journey
          </p>
        </section>

        {/* Registration Process */}
        <section className="registration-section">
          <h2 className="section-title">Registration Process</h2>

          <div className="registration-cards">
            {/* For Students Card */}
            <div className="registration-card">
              <div className="card-icon-wrapper">
                <div className="card-icon green">👨‍🎓</div>
              </div>

              <h3 className="card-title">For Students</h3>
              <p className="card-subtitle">Individual student registration</p>

              <div className="steps-list">
                <div className="step-item">
                  <div className="step-number green">1</div>
                  <div className="step-content">
                    <h4>Create Account</h4>
                    <p>Sign up with your email and basic details</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number green">2</div>
                  <div className="step-content">
                    <h4>Verify Email</h4>
                    <p>Check your inbox and verify your email</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number green">3</div>
                  <div className="step-content">
                    <h4>Complete Profile</h4>
                    <p>Add your class, school, and preferences</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number green">4</div>
                  <div className="step-content">
                    <h4>Start Quizzing</h4>
                    <p>Access practice quizzes immediately</p>
                  </div>
                </div>
              </div>

              <button className="btn-register primary">
                Register as Student
              </button>
            </div>

            {/* For Schools Card */}
            <div className="registration-card">
              <div className="card-icon-wrapper">
                <div className="card-icon blue">🏫</div>
              </div>

              <h3 className="card-title">For Schools</h3>
              <p className="card-subtitle">Institutional registration</p>

              <div className="steps-list">
                <div className="step-item">
                  <div className="step-number blue">1</div>
                  <div className="step-content">
                    <h4>School Registration</h4>
                    <p>Register with official school details</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number blue">2</div>
                  <div className="step-content">
                    <h4>Document Verification</h4>
                    <p>Submit registration certificates</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number blue">3</div>
                  <div className="step-content">
                    <h4>Admin Panel Access</h4>
                    <p>Get dashboard for student management</p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number blue">4</div>
                  <div className="step-content">
                    <h4>Bulk Registration</h4>
                    <p>Register multiple students easily</p>
                  </div>
                </div>
              </div>

              <button className="btn-register secondary">
                Register as School
              </button>
            </div>
          </div>
        </section>

        {/* How to Participate in Quizzes */}
        <section className="participate-section">
          <h2 className="section-title">How to Participate in Quizzes</h2>

          {/* Practice Quizzes */}
          <div className="quiz-type-card practice">
            <div className="quiz-type-header">
              <div className="quiz-icon">📚</div>
              <div className="quiz-info">
                <h3>Practice Quizzes</h3>
                <p>Self-paced learning with no time pressure</p>
              </div>
              {/* <span className="badge green">Free</span> */}
            </div>

            <div className="quiz-steps">
              <div className="quiz-step">
                <div className="step-icon-box">1️⃣</div>
                <h4>Choose Subject</h4>
                <p>Select from 7 core subjects based on your class</p>
              </div>

              <div className="quiz-step">
                <div className="step-icon-box">2️⃣</div>
                <h4>Select Class Level</h4>
                <p>Questions adapted to your academic level</p>
              </div>

              <div className="quiz-step">
                <div className="step-icon-box">3️⃣</div>
                <h4>Start Quiz</h4>
                <p>Practice unlimited times with instant feedback</p>
              </div>
            </div>
          </div>

          {/* Live Quizzes */}
          <div className="quiz-type-card live">
            <div className="quiz-type-header">
              <div className="quiz-icon">▶️</div>
              <div className="quiz-info">
                <h3>Live Quizzes</h3>
                <p>Real-time competitions with prizes</p>
              </div>
              {/* <span className="badge orange">Competitive</span> */}
            </div>

            <div className="quiz-steps four-col">
              <div className="quiz-step">
                <div className="step-icon-box">🔍</div>
                <h4>Browse Live Quizzes</h4>
                <p>Check upcoming quiz schedule</p>
              </div>

              <div className="quiz-step">
                <div className="step-icon-box">📝</div>
                <h4>Register</h4>
                <p>Pay entry fee (if applicable)</p>
              </div>

              <div className="quiz-step">
                <div className="step-icon-box">⏰</div>
                <h4>Join on Time</h4>
                <p>Be online 10 minutes before start</p>
              </div>

              <div className="quiz-step">
                <div className="step-icon-box">🏆</div>
                <h4>Compete & Win</h4>
                <p>Answer fast and accurately</p>
              </div>
            </div>
          </div>
        </section>

        {/* Fee Structure */}
        <section className="fee-section">
          <h2 className="section-title">Fee Structure</h2>

          <div className="fee-cards">
            {/* Free Quizzes */}
            <div className="fee-card">
              <div className="fee-icon">🎁</div>
              <h3>Free Quizzes</h3>
              <div className="price">₹0</div>
              <ul className="features-list">
                <li>✓ All Practice Quizzes</li>
                <li>✓ Regular Live Quizzes</li>
                <li>✓ Basic Certificates</li>
                <li>✓ Progress Tracking</li>
              </ul>
            </div>

            {/* Premium Competitions */}
            <div className="fee-card premium">
              <div className="fee-icon">💳</div>
              <h3>Premium Competitions</h3>
              <div className="price">₹25-₹50</div>
              <ul className="features-list">
                <li>✓ Level-wise Competitions</li>
                <li>✓ Higher Prize Money</li>
                <li>✓ Special Recognition</li>
                <li>✓ Advanced Analytics</li>
              </ul>
            </div>

            {/* National Level */}
            <div className="fee-card national">
              <div className="fee-icon">🏆</div>
              <h3>National Level</h3>
              <div className="price">₹75</div>
              <ul className="features-list">
                <li>✓ National Competition</li>
                <li>✓ Bumper Prizes</li>
                <li>✓ Media Coverage</li>
                <li>✓ Scholarship Opportunities</li>
              </ul>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Ready to Get Started?</h2>
          <p>
            Join thousands of students already learning and competing on
            DocMaster Quiz platform
          </p>
          <div className="cta-buttons">
            <button className="btn-cta primary">Create Free Account</button>
            <button className="btn-cta secondary">Explore Quizzes</button>
          </div>
        </section>

        {/* <footer
          className="quiz-landing-footer bg-blue text-white py-4"
          style={{ backgroundColor: "#062b7a" }}
        >
          <div className="container-fluid text-start">
            <div className="row">
              <div className="col-md-3">
                <a
                  className="navbar-brand"
                  href="/quizhomepage"
                  style={{
                    backgroundColor: "#fff",
                    padding: "15px",
                    borderRadius: "8px",
                  }}
                >
                  <img
                    src="../images/docmasterLogo.png"
                    alt="DocMaster Quiz Logo"
                    className="quiz-landing-logo"
                    style={{ width: "180px" }}
                  />
                </a>
                <div className="d-flex justify-content-center mt-3 mb-3">
                  <p className="text-15 mb-0">
                    Empowering students through interactive learning and
                    competitive quizzes.Building the future of education, one
                    question at a time.
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <h5 className="bold mb-3 text-white">Quick Links</h5>
                <ul className="mb-3">
                  <li>
                    <a href="#" className="text-white mx-3">
                      Dashboard
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      Syllabus
                    </a>
                  </li>
                  <li>
                    <a href="Howtopartcipate.js" className="text-white mx-3">
                      How to Participate
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      Profile
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <h5 className="bold mb-3 text-white">Support</h5>
                <ul className="  mb-3">
                  <li>
                    <a href="#" className="text-white mx-3">
                      FAQ's
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      Terms & Conditions
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      Testimonials
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <h5 className="bold mb-3 text-white">Contact info</h5>
                <ul className=" list-unstyled mb-3">
                  <li>
                    <a href="#" className="text-white mx-3">
                      info@docmasterquiz.com
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      +91 98765 43210
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-white mx-3">
                      Mumbai, Maharastra, India
                    </a>
                  </li>
                </ul>
                <div className="d-flex  justify-content-center mb-3">
                  <a href="#" className="text-white mx-3">
                    <i className="fab fa-facebook "></i>
                  </a>
                  <a href="#" className="text-white mx-3">
                    <i className="fab fa-twitter "></i>
                  </a>
                  <a href="#" className="text-white mx-3">
                    <i className="fab fa-instagram "></i>
                  </a>
                  <a href="#" className="text-white mx-3">
                    <i className="fab fa-linkedin "></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <hr className="mb-4" style={{ borderColor: "#fff" }} />
        </footer> */}
      </div>
    </div>
  );
};

export default Howtopartcipate;
